<script>
import NavBar from "./components/general/navbar/NavBar.vue";
// import Footer from "./components/general/footer/Footer.vue";
import NotificationWrapper from "./components/general/notification/NotificationWrapper.vue";
import LoadingOverlay from "./components/general/loadingOverlay/LoadingOverlay.vue";
import TimeoutModal from "../src/views/TimeoutModal.vue";

export default {
  name: "App",
  components: {
    NavBar,
    NotificationWrapper,
    LoadingOverlay,
    TimeoutModal,
  },
};
</script>

<template>
  <NotificationWrapper />
  <LoadingOverlay />
  <NavBar />
  <router-view />
  <TimeoutModal />
</template>

<style lang="scss">
#app > .cv-grid {
  border-left: 3rem solid transparent;
  margin-top: 3rem;
  // max-width: none;
}

.bx--checkbox-wrapper {
  width: 20px;
}

.bx--tabs--container ~ div {
  background-color: var(--cds-ui-01);
  padding: 2rem;
}

.bx--table-toolbar .bx--btn svg {
  position: absolute;
  right: 1rem;
}

.bx--list-box__menu-item__option,
.bx--list-box__field {
  text-overflow: unset !important;
  overflow-x: scroll;
}

hr {
  width: 95%;
  margin-top: 3%;
  margin-bottom: 3%;
  opacity: 50%;
  border: none;
  border-top: 1px solid var(--cds-border-strong) !important;
}

.detail-tile {
  padding: 0px;
  width: 100%;
  max-width: 1100px;
  background-color: var(--cds-ui-background);
  overflow: auto;
  margin: 0 auto;
}

.detail-tile-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
}

.detail-input-container {
  width: 100%;
  padding-bottom: 1rem;
}

.detail-input-row {
  width: 100%;
}

.detail-description-container {
  padding-bottom: 1rem;
}

.form-container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.form-header-img {
  width: 100%;
  height: auto;
  padding: 0;
  border: 2px solid #82cfff;
  margin: auto;
}

.bx--date-picker.bx--date-picker--single .bx--date-picker__input,
.bx--date-picker,
.bx--date-picker-container {
  width: 100% !important;
}

@media (min-width: 42rem) {
  .detail-input-row {
    display: flex;

    .detail-input-container:nth-child(odd) {
      padding-right: 1rem;
    }

    .detail-input-container:nth-child(even) {
      padding-left: 1rem;
    }
  }
  .resource-form-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 11;
    height: 4rem;
    width: 100vw;
    display: flex;
    flex-direction: row;
    justify-content: right;
    // background-color: var(--cds-ui-02);
    // border-top: 1px solid var(--cds-border-subtle);
  }
  .bx--data-table thead {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .calendar-container {
    .detail-input-container {
      padding-right: 1rem;
    }
  }

  .detail-tile-container {
    padding: 2rem;
  }

  .detail-description-container {
    padding-bottom: 2rem;
  }
}
</style>
